import {userConstants} from '../constants/user.constants.js';

const initialState = {facebook: false, instagram: false};

export const social = (state = initialState, action) => {
    switch (action.type) {
        case userConstants.CHECK_FACEBOOK_SUCCESS:
            return {
                ...state,
                facebook: action.payload
            };
        case userConstants.CHECK_INSTAGRAM_SUCCESS:
            return {
                ...state,
                instagram: action.payload
            };
        case userConstants.CONNECT_FACEBOOK_SUCCESS:
            return {
                ...state,
                facebook: action.payload
            };
        case userConstants.DISCONNECT_FACEBOOK_SUCCESS:
            return {
                ...state,
                facebook: false
            };
        default:
            return state
    }
};

